import gql from 'gql-tag'

export const GET_PATIENT_NAMES = gql`
  query GetPatientNames {
    PatientList(_count: 1000) {
      id
      name {
        text
      }
    }
  }
`
